import { render, staticRenderFns } from "./modalDriverID.vue?vue&type=template&id=524a1bcc&scoped=true"
import script from "./modalDriverID.vue?vue&type=script&lang=js"
export * from "./modalDriverID.vue?vue&type=script&lang=js"
import style0 from "./modalDriverID.vue?vue&type=style&index=0&id=524a1bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a1bcc",
  null
  
)

export default component.exports